
import React, { Fragment } from 'react'

const EmptyTitleAction = () =>
{
	return (
		<Fragment>
		
		</Fragment>
	)
}

export default EmptyTitleAction
